import { motion } from "framer-motion";
import { Menu } from "lucide-react";
import { useCart } from "@/context/CartContext";

const links = [
  { label: "Inventory", href: "#inventory" },
  { label: "How It Works", href: "#how" },
  { label: "Reviews", href: "#reviews" },
  { label: "Call Us", href: "#call" },
];

export default function Navbar() {
  const { count, setOpen } = useCart();

  const go = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
      className="fixed top-4 inset-x-3 md:inset-x-6 z-50"
      data-testid="navbar"
    >
      <div className="mx-auto max-w-6xl flex items-center justify-between rounded-full border border-black/5 bg-white/70 backdrop-blur-xl px-4 md:px-6 py-3 shadow-sm">
        <a href="#top" onClick={(e) => go(e, "#top")} className="flex items-center gap-2" data-testid="logo">
          <img
            src="https://customer-assets-lqy194kg.emergentagent.net/job_party-gear-rent/artifacts/nv7bbj0o_Logo%20Fiestas%20Moderno%20Simple%20en%20Negro%20y%20Rosa%20%281%29.png"
            alt="Cornerstone Celebrations"
            className="h-11 md:h-12 w-auto object-contain"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              className="text-sm font-600 text-ink/70 hover:text-brand-coral transition-colors"
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          onClick={() => setOpen(true)}
          className="group flex items-center gap-2 rounded-full bg-ink text-white pl-4 pr-3 py-2 text-sm font-700 hover:bg-brand-coral transition-colors"
          data-testid="open-booking-btn"
        >
          Book Now
          <span className="grid place-items-center h-6 min-w-6 px-1 rounded-full bg-brand-coral text-white text-xs group-hover:bg-white group-hover:text-brand-coral transition-colors">
            {count}
          </span>
        </button>
      </div>
    </motion.header>
  );
}
